module.exports = __webpack_public_path__ + "static/media/pw-wins-active-icon.4ec6cefb.svg";